// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"e3f52483","239":"7741c8fe","455":"2498014a","936":"5ca0e48a","977":"931b0271"}[chunkId] + ".chunk.js";
};